<template>
  <div class="table-wrapper" unselectable="on">
    <LoaderWait v-show="loading"/>
    <table class="main-table">
      <tr>
        <td class="td-logo" width="30%"><img :src="logo"></td>
        <td width="40%" align="center" style="vertical-align: top"><div class="info-text">Оплата {{ nameProv }}</div></td>
        <td width="30%"></td>
      </tr>
      <tr>
        <td colspan="3" align="center">
          <div class="input-head-text">Подтвердите введенные данные</div>
        </td>
      </tr>
      <tr>
        <td class="bg-confirm" colspan="3" align="center">
          <div class="main-text" v-for="(item, k) in inputsFormated" :key="k">
            {{item.label}}: {{item.value}}
          </div>
        </td>
      </tr>
      <tr>
        <td class="td-row" colspan="3" align="center">
          <table style="width: 100%" class="main-text">
            <tr>
              <td width="70%">Сумма к зачислению:</td>
              <td width="30%" align="right">{{ sum }} руб.</td>
            </tr>
            <tr>
              <td width="70%">Комиссия:</td>
              <td width="30%" align="right">{{ comis }} руб.</td>
            </tr>
            <tr>
              <td width="70%">Сумма к оплате:</td>
              <td width="30%" align="right">{{ sumFull }} руб.</td>
            </tr>
          </table>
        </td>
      </tr>
      <tr>
        <td class="td-nav" width="30%">
          <img @click="backClick" src="/imgs/back_1.png">
        </td>
        <td class="td-nav" width="40%" align="center">
          <img @click="mainClick" src="/imgs/menu_impay_1.png">
        </td>
        <td class="td-nav" width="30%" align="right">
          <img @click="fwdClick" src="/imgs/fwd_1.png">
        </td>
      </tr>
    </table>
    <MessageBox :message="errorMessage" v-show="showMessage" :on-close="messageClose"></MessageBox>
  </div>
</template>

<style>

</style>
<script>
import LoaderWait from "@/components/LoaderWait.vue";
import MessageBox from "@/components/MessageBox.vue";
import {formatMask} from "@/utils/format_mask";
import {moneyFormat} from "@/utils/money_format";
import {calcComis} from "@/utils/calc_comis";

export default {
  name: 'InputConfirmPage',
  components: { MessageBox, LoaderWait },
  data () {
    return {
      loading: false,
      timer: null,
      showMessage: false,
      errorMessage: '',
    }
  },
  computed: {
    prov() {
      const data = this.$store.getters.PROV_INFO
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    amount() {
      const data = this.$store.getters.AMOUNT_PROV
      if (data !== null) {
        return data
      } else {
        return 0.0
      }
    },
    inputs() {
      const data = this.$store.getters.INPUTS_PROV
      if (data !== null) {
        return data
      } else {
        return []
      }
    },
    logo() {
      if (this.prov !== null) {
        return '/imgs/op/' + this.prov.img;
      }
      return '/imgs/logo_impay.png'
    },
    user() {
      const data = this.$store.getters.GET_USER_PROFILE
      if (data !== null) {
        return data
      } else {
        return null
      }
    },
    inputsFormated() {
      if (this.inputs !== null && this.prov !== null) {
        let ret = []
        for (let i = 0; i < this.prov.fields.length; i++) {
          const field = this.prov.fields[i]
          const input = this.inputs[i]
          ret.push({label: field.label, value: formatMask(input, field.mask)})
        }
        return ret;
      }
      return []
    },
    sum() {
      return moneyFormat(this.amount)
    },
    comis() {
      if (this.prov !== null) {
        return moneyFormat(calcComis(this.amount, this.prov.comission, this.prov.comissiontp));
      }
      return 0
    },
    sumFull() {
      if (this.prov !== null) {
        return moneyFormat(this.amount + calcComis(this.amount, this.prov.comission, this.prov.comissiontp));
      }
      return 0
    },
    nameProv() {
      if (this.prov !== null) {
        return this.prov.name
      }
      return 'услуги'
    }
  },
  mounted() {
    this.updateTimer()
  },
  methods: {
    updateTimer() {
      this.stopTimer()
      this.timer = setTimeout(() => this.timerExit(), 60000)
    },
    stopTimer() {
      if (this.timer !== null) {
        clearTimeout(this.timer);
        this.timer = null;
      }
    },
    timerExit() {
      this.$store.dispatch('AUTH_LOGOUT')
    },
    fwdClick() {
      if (this.loading) {
        return false;
      }

      this.stopTimer()
      this.loading = true

      const comis = Math.round(calcComis(this.amount, this.prov.comission, this.prov.comissiontp) * 100.0)
      const sum = Math.round(this.amount * 100.0 + comis)
      this.$store.dispatch('GET_PAY_CREATE', {
        phone: this.user.phone,
        prov: this.prov.id,
        params: this.inputs,
        amount: sum,
        comis: comis
      }).then((res) => {
        this.loading = false
        if (res.status == 1) {
          this.$router.push('pay-end')
        } else {
          this.updateTimer()
          this.messageShow('Ошибка запроса, попробуйте повторить позднее')
        }
      }).catch((e) => {
        this.loading = false
        if (e.response !== undefined && e.response.status === 401) {
          this.$store.dispatch('AUTH_LOGOUT')
        }
      })
    },
    backClick() {
      this.stopTimer()
      this.$router.go(-1)
    },
    mainClick() {
      this.stopTimer()
      this.$router.go(-3)
    },
    messageShow(message) {
      this.showMessage = true;
      this.errorMessage = message;
      // Возвращаем Promise, который будет разрешён в messageClose
      return new Promise((resolve) => {
        this.messagePromiseResolver = resolve;
      });
    },
    messageClose() {
      this.showMessage = false;
      this.errorMessage = '';
      // Разрешаем Promise, если он существует
      if (this.messagePromiseResolver) {
        this.messagePromiseResolver();
        this.messagePromiseResolver = null;
      }
    },
  }
}
</script>

<style scoped>

</style>
